/**
 * 注文情報データクラス
 * */
export class orderInfo {

	// ハガキ種(私製喪中など)
	public postcardType: string;

	// 編集開始日(暗号化)
	public num: number;

	// カスタマーID
	public customerId: string;

	// 1枚お試しフラグ
	public isTrial: boolean;
}